<div class="layout-topbar" style="display: flex; justify-content: space-between; align-items: center;">
    <img src="assets/images/MM Home.jpg" alt="logo">

    <div style="display: flex; justify-content: space-between; align-items: center;">
        <div *ngIf="testee" class="font-bold" style="color: #883CAE; float: right;">Hi {{testee.firstName}}</div>
        <p-menu #menu2 [model]="items" [popup]="true" appendTo="body"></p-menu>
        <button style="color: #883CAE"
            class="p-link inline-flex justify-content-center align-items-center h-3rem w-3rem"
            (click)="menu2.toggle($event)"><i class="pi pi-user text-2xl"></i></button>
    </div>
</div>